import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

interface LayoutHeaderProps {
  propertyName?: string;
  propertyId?: string;
}

export const LayoutHeader = ({
  propertyName,
  propertyId
}: LayoutHeaderProps) => {
  const dictionary = useUnitsPropertiesDictionary();

  return (
    <div className="flex gap-2.5 p-3">
      <BreadCrumbs
        crumbs={[
          {
            title: dictionary.Properties,
            href: "/properties"
          },
          {
            title: propertyName || "Property",
            href: `/properties/${propertyId}`
          },
          {
            title: `Add ${dictionary.unit}`,
            href: `/properties/${propertyId}/units/add`
          }
        ]}
      />
    </div>
  );
};
